export default {
  exhibit: null,
  record: null,
  records: null,
  loading: false
};


// WEBPACK FOOTER //
// ./src/reducers/map/mapShow-initialState.js